<template>
    <div>
        <div class="row">
            <stats-card v-loading="loader" type="warning" icon="ti-cup" title="Pierwsze uruchomienia aplikacji"
                        :value="statsValue.first" footerText="test" formatValue="false"
                        footerIcon="ti-timer"></stats-card>
            <stats-card v-loading="loader" type="success" icon="ti-wallet" title="Dodanie nowego podatnika"
                        :value="statsValue.strong" formatValue="false"
                        footerText="test"
                        footerIcon="ti-timer"></stats-card>
            <stats-card v-loading="loader" type="danger" icon="ti-info"
                        title="Suma wszystkich wypełnionych deklaracji"
                        :value="statsValue.upo_count" formatValue="false"
                        footerText="test"
                        footerIcon="ti-timer"></stats-card>
            <stats-card v-loading="loader" type="info" icon="ti-email" title="Liczba wysłanych eDeklaracji"
                        :value="statsValue.upo_send_count"
                        footerText="test" formatValue="false"
                        footerIcon="ti-timer"></stats-card>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card cardText">
                    <p>Podane w naszych statystykach <strong>wpłaty 1% są kwotami szacunkowymi</strong>,
                        wynikającymi z zastosowania odpowiednich współczynników opartych
                        na danych statystycznych z poprzednich lat, które
                        generuje program PIT Format. Brane są pod uwagę kwoty 1% wskazane przez podatników w
                        deklaracjach: <strong>zapisanych jako pdf, wydrukowanych oraz wysłanych jako eDeklaracja</strong>.

                        Dane te mają charakter poglądowy, ponieważ nie jest możliwy pełny i dokładny
                        monitoring wpłat 1%, np. nastąpiło wydrukowanie czy zapisanie pdf deklaracji w programie, ale
                        nie dostarczono jej finalnie do urzędu skarbowego.<br>
                        Wg naszych analiz wskazane kwoty mogą mieć odchylenie rzędu -/+ 10 %.
                    </p>
                </div>
            </div>
        </div>
        <div class="row">
            <bar-chart title="Pierwsze uruchomienia" url="api/legacy/first" time="200000" localName="first"></bar-chart>
        </div>
        <div class="row">

            <bar-chart title="Pierwsze dodanie podatnika" url="api/legacy/strong" time="200000"
                       localName="strong"></bar-chart>
        </div>
        <div class="row">
            <bar-chart title="Suma wszystkich wypełnionych deklaracji" url="api/legacy/wyp" type="count" time="200000"
                       localName="wyp"></bar-chart>
        </div>
        <div class="row">
            <bar-chart title="Liczba wysłanych eDeklaracji" url="api/legacy/upo" time="200000" type="count"
                       type_form="pc_send"
                       localName="sendCount"></bar-chart>
        </div>

    </div>
</template>
<script type="text/babel">
  import StatsCard from 'components/UIComponents/Cards/StatsCard.vue'
  import BarChart from 'components/UIComponents/Charts/BarChart.vue'
  import ApiLocalStorage from 'src/helpers/ApiLocalStorage'

  export default {
    components: {
      StatsCard,
      BarChart
    },
    mounted () {
      this.getCardsData('api/legacy/global-cards')
    },
    data () {
      return {
        loader: false,
        statsValue: {
          first: 0,
          strong: 0,
          upo_count: 0,
          upo_send_count: 0
        }
      }
    },
    watch: {
      lic: function () {
        this.getCardsData('api/legacy/global-cards')
      }
    },
    computed: {
      lic () {
        return this.$store.getters.lic
      }
    },
    methods: {
      getCardsData (apiUrl) {
        this.loader = true
        ApiLocalStorage.requestData('cardsFills' + this.lic, apiUrl, 'post', {'lic': this.lic}, 900000).then((data) => {
          this.fillData(data)
          setTimeout(() => {
            this.loader = false
          }, 1)
        })
      },
      fillData (data) {
        this.statsValue.first = data.first
        this.statsValue.strong = data.strong
        this.statsValue.upo_count = data.upo_count
        this.statsValue.upo_send_count = data.upo_send_count
      }
    }
  }

</script>
<style>


</style>



// WEBPACK FOOTER //
// Fillings.vue?abb0b94a